import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { compose } from "redux";
import _ from "lodash";

import close from "assets/images/close1.png";
import logo from "assets/images/heylime-logo.png";
import personMobile from "assets/images/person-mobile.png";
import * as gameAction from "redux/game/action";
import { withSocket } from "socket/context";

const WrongHost = (props) => {
  const allParams =
    _.get(props, "gameReducer.gamesData.onboarding.login") || "";

  const handleClose = () => {
    sessionStorage.removeItem("gameCode");
    props.setGameName("");
    props.history.push("/");
  };

  const handleAccount = async () => {
    localStorage.removeItem("auth");
    sessionStorage.removeItem("gameCode");
    await Auth.signOut()
      .then((user) => {
        props.endGame(true);
        props.setCurrentUser({});
        props.history.push("/signup");
      })
      .catch((err) => {});
    props.history.push("/signup");
  };

  return (
    <>
      <div className="game-select-head">
        <img onClick={() => props.history.push("/")} src={logo} alt="logo" />
      </div>
      <div className="position-relative">
        <div className="need-account">
          <div className="need-account-inner">
            <img
              alt=""
              className="person-mobile"
              src={allParams ? allParams?.graphic : personMobile}
            />
            <h4>
              {allParams ? allParams?.banner_text : "Need an account to host?"}
            </h4>
            <p>
              {allParams
                ? allParams?.instructions_text
                : "Continue with a social account below to log <br/> in or create a new account."}
            </p>
          </div>
          <button
            className="switch-btn btn btn-secondary"
            onClick={() => handleAccount()}
          >
            Switch Account
          </button>
        </div>
      </div>
      <button className="close-btn" onClick={() => handleClose()}>
        <img alt="" src={close} />
      </button>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setCurrentUser: (data) => dispatch(gameAction.setCurrentUser(data))
  };
};
export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(WrongHost);
